import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  statusLabelAuthorized: {
    color: '#16A63C',
    backgroundColor: '#B4FFC8',
  },
  statusLabelRevoked: {
    color: '#DC3545',
    backgroundColor: '#FFE0E3',
  },
  statusLabelPendent: {
    color: '#ba8b00ff',
    backgroundColor: '#FFF3CD',
  },
}))

export default styles
